import axios from "axios"
// import { saveAs } from "file-saver" // Falls du das brauchst, drin lassen

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  const token = localStorage.getItem("token")
  if (token) {
    options.headers.Authorization = token
  }

  // Wichtig für JSON Body bei fetch
  options.headers["Content-Type"] = "application/json"

  return options
}

export default {
  // Deine anderen Methoden...
  mail: {
    async getFolders() {
      return axios.get(buildUrl("mail/folders"), buildOptions()).then((r) => r.data)
    },
    async getMails(params = {}) {
      const query = new URLSearchParams(params).toString()
      return axios.get(buildUrl(`mail/mails?${query}`), buildOptions()).then((r) => r.data)
    },
    async sync() {
      // Sync wartet nun auf Response
      return axios.post(buildUrl("mail/sync"), {}, buildOptions()).then((r) => r.data)
    },
    async send(payload) {
      return axios.post(buildUrl("mail/send"), payload, buildOptions()).then((r) => r.data)
    },
    async update(id, payload) {
      return axios.patch(buildUrl(`mail/${id}`), payload, buildOptions()).then((r) => r.data)
    },
    // NEU: Manual TAC Lookup
    async manualTacLookup(email) {
      return axios.get(buildUrl(`mail/tac-lookup?email=${encodeURIComponent(email)}`), buildOptions()).then((r) => r.data)
    },
    // NEU: Regenerate AI
    async regenerate(payload) {
      return axios.post(buildUrl("mail/regenerate"), payload, buildOptions()).then((r) => r.data)
    },
  },
  ai: {
    async fake(payload) {
      const url = buildUrl("ai/fake")
      return axios.post(url, payload, buildOptions()).then((res) => res.data)
    },

    async streamChat(payload, signal) {
      const url = buildUrl("ai/chat")

      // Payload muss bei fetch manuell stringified werden
      const options = buildOptions(
        {
          method: "POST",
          body: JSON.stringify(payload),
        },
        signal
      )

      return fetch(url, options)
    },
  },
  /**
   * Sendet eine Chat-Nachricht und gibt den rohen Response-Stream zurück.
   * Wir nutzen hier fetch statt axios für besseres Stream-Handling im Browser.
   */
}
